__turbopack_context__.v({
  "content-layout": "B_Qsfa_content-layout",
  "coverage-notice": "B_Qsfa_coverage-notice",
  "document-header": "B_Qsfa_document-header",
  "error-message": "B_Qsfa_error-message",
  "main-workspace": "B_Qsfa_main-workspace",
  "message": "B_Qsfa_message",
  "notice-message": "B_Qsfa_notice-message",
  "preview-message": "B_Qsfa_preview-message",
  "recipe-pane": "B_Qsfa_recipe-pane",
  "root": "B_Qsfa_root",
  "saved-schedules": "B_Qsfa_saved-schedules",
  "toolbar-actions": "B_Qsfa_toolbar-actions",
  "toolbar-left": "B_Qsfa_toolbar-left",
  "workspace-toolbar": "B_Qsfa_workspace-toolbar",
});
